/** Tracks preview request generations so stale asynchronous responses cannot commit. */
export class PreviewLifecycle {
  private generation = 0;

  public begin(): number {
    this.generation += 1;
    return this.generation;
  }

  public isCurrent(generation: number): boolean {
    return generation === this.generation;
  }

  public invalidate(): void {
    this.generation += 1;
  }
}
